

























































import {Component, Prop, Vue} from "vue-property-decorator";


import {dateFormat} from "@/script/moment";
import {AxiosError, AxiosResponse} from "axios";
import {mapGetters} from "vuex";
import UserAvatar from "@/components/user/_userAvatar.vue";
import CommentInput from "@/components/comment/_commentInput.vue";
import {User} from "@/types";
import ClickManager from "@/script/clickManager";

@Component({
    computed: {...mapGetters(["user"])},
    components: {UserAvatar, CommentInput},
})
export default class Comment extends Vue {
    @Prop() comment!: any;
    @Prop() postId!: any;
    userInfo: any = [];
    content: string = this.comment.content;
    isEditing: boolean = false;
    parentId: number = -1;
    modalTitle: string = "Report Comment";
    createdDate: string = "";
    updatedContent: string = '';


    showModal: boolean = false;
    user!: User;
    clickManager: ClickManager = new ClickManager();
    isLiked: boolean = this.comment.is_liked;
    likeCnt: number = this.comment.like_cnt

    mounted() {
        this.init();
        this.createdDate = dateFormat(this.comment.createdAt);
        this.updatedContent = this.comment.content
    }

    async init() {
        const result = await this.$api.channel(this.comment.user.channel_id);
        this.userInfo = result.target;
    }

    editPost() {
        this.isEditing = true;
        (this.$refs.dropbox as HTMLElement).click();
    }

    editDone() {
        this.isEditing = false;
        this.$emit('editDone')
    }
    updateDone(comment:any) {
        this.isEditing = false;
        this.updatedContent = comment.content
        // this.$emit('updateDone')
    }

    editComment() {
        this.isEditing = true;
    }


    sendLike(state: boolean) {
        if (this.user) {
            if (state) {
                if (!this.clickManager.doubleClickCheck()) {
                    this.$api.unlikeComment(this.postId, this.comment.id)
                        .then((res: AxiosResponse) => {
                            this.isLiked = false;
                            this.likeCnt--;
                            // this.$emit('editDone')

                        })
                        .catch((err: AxiosError) => {

                        })
                }
            }
            else {
                if (!this.clickManager.doubleClickCheck()) {
                    this.$api.likeComment(this.postId, this.comment.id)
                        .then((res: AxiosResponse) => {
                            this.isLiked = true;
                            this.likeCnt++;
                            // this.$emit('editDone')
                        })
                        .catch((err: AxiosError) => {

                        })
                }
            }
        }
        else {
            this.$modal.show('needLogin')
        }

    }

    moveUserChannel(channel_id: string) {
        this.$router.push(`/${this.$i18n.locale}/channel/${channel_id}/timeline`)
    }

}
